import { render } from "./VerifyFormComponent.vue?vue&type=template&id=394e75e0&scoped=true&ts=true"
import script from "./VerifyFormComponent.vue?vue&type=script&lang=ts"
export * from "./VerifyFormComponent.vue?vue&type=script&lang=ts"

import "./VerifyFormComponent.vue?vue&type=style&index=0&id=394e75e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394e75e0"]])

export default __exports__